import { PaginaCrud } from '../components/PaginaCrud'
import type { Cliente } from '../types'

export default function Clientes() {
  return (
    <PaginaCrud<Cliente>
      titulo="Clientes"
      recurso="clientes"
      llave="id"
      columnas={[
        { campo: 'codigo', titulo: 'Codigo' },
        { campo: 'nombre', titulo: 'Nombre' },
        { campo: 'contacto', titulo: 'Contacto', render: (c) => c.contacto || '-' },
        { campo: 'telefono', titulo: 'Telefono', render: (c) => c.telefono || '-' },
        { campo: 'activo', titulo: 'Activo', render: (c) => (c.activo ? 'Si' : 'No') },
      ]}
      campos={[
        { nombre: 'codigo', etiqueta: 'Codigo', tipo: 'texto', requerido: true },
        { nombre: 'nombre', etiqueta: 'Nombre', tipo: 'texto', requerido: true },
        { nombre: 'contacto', etiqueta: 'Contacto', tipo: 'texto' },
        { nombre: 'telefono', etiqueta: 'Telefono', tipo: 'texto' },
        { nombre: 'activo', etiqueta: 'Activo', tipo: 'checkbox' },
      ]}
      valorInicial={{ tenantId: 1, activo: true }}
    />
  )
}
